/* eslint camelcase: off */

import React, { Fragment, useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import Cookies from 'js-cookie'
import Moment from 'moment'
import _ from 'lodash'

const setCookies = (new_medium, new_campaign, new_track_lead_page, referrer) => {
  let utm_source
  const url_source = new URL(window.location.href).searchParams.get('utm_source')
  if (url_source) {
    utm_source = url_source
  } else if (referrer) {
    utm_source = referrer
  } else {
    utm_source = 'direct'
  }

  const utm_medium = Cookies.get('utm_medium')
    ? Cookies.get('utm_medium')
    : 'organic'
  const first_visit_date = Cookies.get('first_visit_date')
    ? Cookies.get('first_visit_date')
    : Moment().format('YYYY-MM-DD')
  const first_visit_path = Cookies.get('first_visit_path')
    ? Cookies.get('first_visit_path')
    : new_track_lead_page

  if (new_campaign) {
    utm_source = 'ppc'
  }

  Cookies.set('utm_source', utm_source, {
    expires: 90,
    sameSite: 'lax'
  })

  Cookies.set('utm_medium', new_medium || utm_medium, {
    expires: 90,
    sameSite: 'lax'
  })
  Cookies.set('utm_campaign', new_campaign || 'none', {
    expires: 90,
    sameSite: 'lax'
  })
  Cookies.set(
    'track_lead_page',
    new_track_lead_page || '',
    {
      expires: 90,
      sameSite: 'lax'
    }
  )
  Cookies.set('first_visit_date', first_visit_date, {
    expires: 90,
    sameSite: 'lax'
  })
  Cookies.set('first_visit_path', first_visit_path, {
    expires: 90,
    sameSite: 'lax'
  })
}

const getSingleParam = (props, name) => {
  const search = getUrlParams(props)
  return search.get(name) || ''
}

const getUrlParams = props => {
  if (!props) return new URLSearchParams()
  return new URLSearchParams(props)
}

const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const Layout = props => {
  const search = props.location.search
  const utm_medium = getSingleParam(search, 'utm_medium')
  const utm_campaign = getSingleParam(search, 'utm_campaign')
  const track_lead_page = window.location.pathname
  const prevLoc = usePrevious(props.location.pathname)

  useEffect(() => {
    const referrer = document.referrer.split('/')[2]
    setCookies(utm_medium, utm_campaign, track_lead_page, referrer)
  })

  useEffect(() => {
    const currentLocation = window.location.pathname

    const pathArr = currentLocation.split('/').splice(1)

    let endPath = ''

    _.map(pathArr, (path, index) => {
      if (path !== '') {
        endPath = endPath + '/' + path
      }
    })
    if (pathArr[pathArr.length - 1] === '') {
      props.history.push(endPath)
    }
  }, [props.history])

  if (props.location.pathname === '/404' && prevLoc) {
    fetch('https://hooks.zapier.com/hooks/catch/3349564/ohssa9q/', {
      method: 'POST',
      body: JSON.stringify({
        source: prevLoc
      })
    })
      .then(response => {})
      .catch(error => {
        console.error('Error:', error)
      })
  }

  return (
    <Fragment>
      <main>{props.children}</main>
    </Fragment>
  )
}

export default withRouter(Layout)
